import { IRecipient, IDonor } from '@nkr/models/index';
import { Panel } from 'react-bootstrap';
import { MedicalDemographicPreferencesTableWrapper } from './styles';

interface IProps {
    donor: IDonor,
    recipient: IRecipient
}

const MedicalDemographicInfo = (props: IProps) => {
    const { donor, recipient } = props;

    return (
        <Panel className='medical-demographic-info'>
            <Panel.Heading><span className='heading medium'>Medical &amp; Demographic Info</span></Panel.Heading>
            <Panel.Body>
                <MedicalDemographicPreferencesTableWrapper condensed striped>
                    <tbody>
                        <tr>
                            <td style={{ width: '15%' }}><span className={'label label-eval ' + (donor.hepBAntigen == 'POS' ? 'label-warning' : 'label-default')}>{donor.hepBAntigen == '' || donor.hepBAntigen == 'DNK' ? '?' : donor.hepBAntigen}</span></td>
                            <td><label htmlFor='HepBAntigen'>Hepatitis B Antigen</label></td>
                        </tr>
                        <tr>
                            <td><span className={'label label-eval ' + (donor.hepBAntibody == 'POS' ? 'label-warning' : 'label-default')}>{donor.hepBAntibody == '' || donor.hepBAntigen == 'DNK' ? '?' : donor.hepBAntibody}</span></td>
                            <td><label htmlFor='HepBAntibody'>Hepatitis B Core Antibody</label></td>
                        </tr>
                        <tr>
                            <td><span className={'label label-eval ' + (donor.antiHcv == 'POS' ? 'label-warning' : 'label-default')}>{donor.antiHcv == '' || donor.antiHcv == 'DNK' ? '?' : donor.antiHcv}</span></td>
                            <td><label htmlFor='AntiHcv'>Anti-HCV</label></td>
                        </tr>
                        <tr>
                            <td><span className={'label label-eval ' + (donor.hiv == 'POS' ? 'label-warning' : 'label-default')}>{donor.hiv == '' || donor.hiv == 'DNK' ? '?' : donor.hiv}</span></td>
                            <td><label htmlFor='Hiv'>HIV</label></td>
                        </tr>
                        <tr>
                            <td><span className={'label label-eval ' + (donor.rprVdrl == 'POS' ? 'label-warning' : 'label-default')}>{donor.rprVdrl == '' || donor.rprVdrl == 'DNK' ? '?' : donor.rprVdrl}</span></td>
                            <td><label htmlFor='RprVdrl'>RPR/VDRL</label></td>
                        </tr>
                        <tr>
                            <td><span className='label label-eval label-default'>{donor.ebv == '' || donor.ebv == 'DNK' ? '?' : donor.ebv}</span></td>
                            <td><label htmlFor='ebv'>EBV</label></td>
                        </tr>
                        <tr>
                            <td><span className={'label label-eval label-default'}>{donor.cmv == '' || donor.cmv == 'DNK' ? '?' : donor.cmv}</span></td>
                            <td><label htmlFor='cmv'>CMV</label></td>
                        </tr>
                        <tr>
                            <td><span className='label label-eval label-default'>{donor.tbStatus.substring(0, 3).toUpperCase()}</span></td>
                            <td><label htmlFor='tb'>TB</label></td>
                        </tr>
                        <tr>
                            <td><span className='label label-eval label-default'>{donor.hasHistoryOfSmoking ? 'YES' : 'NO'}</span></td>
                            <td><label htmlFor='tb'>HX of Smoking</label></td>
                        </tr>
                        <tr>
                            <td><span className={'label label-eval '+ (donor.isAtRisk == 'YES' ? 'label-warning' : 'label-default')}>{donor.isAtRisk}</span></td>
                            <td><label htmlFor='tb'>HX of At Risk Activity</label></td>
                        </tr>
                        <tr>
                            <td><span className='label label-eval label-default'>{donor.bmi}</span></td>
                            <td><label htmlFor='tb'>BMI</label></td>
                        </tr>
                        <tr>
                            <td colSpan={2} style={{ textAlign: 'left' }}>
                                <div style={{ paddingTop: 15, paddingLeft: 10 }}>
                                    <div><strong>Recipient insurance</strong></div>
                                    <div style={{ marginBottom: 10 }}>{recipient.insurance.primaryGroupName}</div>

                                    <div><strong>Reason for recipient kidney failure</strong></div>
                                    <div>{recipient.reasonForKidneyFailure != '' ? recipient.reasonForKidneyFailure : 'No Reason Entered'}</div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </MedicalDemographicPreferencesTableWrapper>
            </Panel.Body>
        </Panel>
    );
}

export default MedicalDemographicInfo;